type ToastTone = 'info' | 'success' | 'warning' | 'danger';

/** How long a success toast stays; the kit's own default, written down here so the rule has one home. */
export const SUCCESS_TOAST_MS = 5000;
/** How long a switch or revoke notice stays. */
export const NOTICE_TOAST_MS = 4000;

/**
 * Toast options by tone: an error stays until the person dismisses it (0), a success goes after about 5 s, any other notice after 4 s.
 * The kit pauses on hover and announces as `alert` for errors by itself only if it implements it: it does not (see the MR).
 */
export function toastDuration(tone: ToastTone): number {
  if (tone === 'danger') return 0;
  return tone === 'success' ? SUCCESS_TOAST_MS : NOTICE_TOAST_MS;
}
